import { useQuery } from '@tanstack/react-query';
import { getAvailableDatabases } from '@/core/utils';
import { databaseKeyFactory } from '@/core/query-keys';

export function useAvailableDatabases() {
  return useQuery(databaseKeyFactory.available, () => getAvailableDatabases());
}
